export const translations = {
  en: {
    translation: {
      message:
        "Hello web adventurer! 🚀 It seems you've landed on my portfolio while I'm still adding some magical touches 🎩✨. If you stumble upon a trick that doesn't execute perfectly, or an animation that seems to have a mind of its own, don't be alarmed! I'm in the midst of taming those rogue bugs 🐞. I invite you to come back soon to enjoy the full show. In the meantime, feel free to explore, but watch out for those rough edges! Thanks for your patience and for being part of this journey. See you soon! 😊"
    }
  },
  es: {
    translation: {
      message:
        '¡Hola aventurero/a de la web! 🚀 Parece que has aterrizado en mi portafolio mientras aún estoy añadiendo algunos toques mágicos 🎩✨. Si encuentras algún truco que no se ejecuta a la perfección, o una animación que parece tener vida propia, ¡no te alarmes! Estoy en pleno proceso de domar esos bugs rebeldes. 🐞 Te invito a volver pronto para disfrutar del show completo. Mientras tanto, siéntete libre de explorar, pero ¡cuidado con los bordes sin pulir! Gracias por tu paciencia y por ser parte de esta aventura. ¡Hasta pronto! 😊'
    }
  }
};
